"use strict";
// _slider.js — Swiper 初期化を集約（本体は functions.php で読み込み済み）

/* =========================================================
   work カルーセル（.l-top-work）
   スライド間隔は CSS 変数 --work-slide-gap を spaceBetween へ反映
========================================================= */
{
  const initWorkSlider = () => {
    if (typeof Swiper === "undefined") return;

    const swiperEl = document.querySelector(".p-top-work__swiper");
    if (!swiperEl) return;

    const prevEl = document.querySelector(".p-top-work__navBtn.-navBtn--prev");
    const nextEl = document.querySelector(".p-top-work__navBtn.-navBtn--next");
    const currentEl = document.querySelector(".p-top-work__paginationCurrent");
    const totalEl = document.querySelector(".p-top-work__paginationTotal");
    const mql = window.matchMedia("(max-width: 768px)");

    const pad2 = (num) => String(num).padStart(2, "0");

    const readCssGap = () => {
      const probe = document.createElement("div");
      probe.style.cssText =
        "position:absolute;visibility:hidden;width:var(--work-slide-gap);pointer-events:none;";
      swiperEl.appendChild(probe);
      const gapPx = probe.getBoundingClientRect().width;
      probe.remove();
      return gapPx;
    };

    let gap = readCssGap();
    const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 54,
      loop: true,
      loopedSlides: slideCount,
      speed: 600,
      watchOverflow: true,
      navigation: {
        prevEl,
        nextEl,
      },
    });

    // フラクション（現在 / 総数）を更新
    const updatePagination = () => {
      if (currentEl) currentEl.textContent = pad2(swiper.realIndex + 1);
      if (totalEl) totalEl.textContent = `/${pad2(slideCount)}`;
    };
    updatePagination();
    swiper.on("slideChange", updatePagination);

    const syncLayout = () => {
      const next = readCssGap();
      if (next !== gap) {
        gap = next;
        swiper.params.spaceBetween = gap;
      }
      swiper.update();
    };

    syncLayout();
    mql.addEventListener("change", syncLayout);

    swiperEl.querySelectorAll("img").forEach((img) => {
      if (img.complete) return;
      img.addEventListener("load", syncLayout, { once: true });
    });

    let resizeTimer = 0;
    window.addEventListener("resize", () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncLayout, 150);
    });
  };

  initWorkSlider();
}

/* =========================================================
   interview スライダー（.l-top-interview）
   SP（767px以下）のみ Swiper を生成し、PC は CSS の縦積みに委ねる
========================================================= */
{
  const initInterviewSlider = () => {
    if (typeof Swiper === "undefined") return;

    const swiperEl = document.querySelector("[data-interview-slider]");
    if (!swiperEl) return;

    const prevEl = document.querySelector("[data-interview-prev]");
    const nextEl = document.querySelector("[data-interview-next]");
    // _variables.scss の $breakpoint と揃える
    const mql = window.matchMedia("(max-width: 767px)");

    let swiper = null;

    const setActiveSlide = (sw) => {
      const slides = swiperEl.querySelectorAll(".p-top-interview__slide");
      slides.forEach((slide) => {
        const index = slide.getAttribute("data-swiper-slide-index");
        slide.classList.toggle(
          "is-active",
          index !== null && Number(index) === sw.realIndex
        );
      });
    };

    const create = () => {
      if (swiper) return;
      const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
      if (slideCount === 0) return;
      swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: slideCount > 1,
        loopedSlides: slideCount > 1 ? slideCount : undefined,
        speed: 500,
        navigation: {
          prevEl,
          nextEl,
        },
        on: {
          init: setActiveSlide,
          slideChange: setActiveSlide,
        },
      });
    };

    const destroy = () => {
      if (!swiper) return;
      swiper.destroy(true, true);
      swiper = null;
    };

    const apply = (isSp) => {
      if (isSp) {
        create();
      } else {
        destroy();
      }
    };

    apply(mql.matches);
    mql.addEventListener("change", (event) => apply(event.matches));
  };

  initInterviewSlider();
}
